export const initState = {
	productType: '',

	fetchAll: {
		_list: 'init',
		$list: [],
	},

	addItem: {
		_add: 'init',

		show: false,

		item: {
			name: '',
			symbol: '',
			buyPrice: '',
			sellPrice: '',
			innerBuyPrice: '',
			innerSellPrice: '',
			orderNumber: '',
			isVisible: 'N',
			isHead: 'N',
		},
	},

	editItem: {
		_edit: 'init',

		sendVerificationCode: false,
		verificationPercent: '',

		item: {
			id: '',
			name: '',
			symbol: '',
			buyPrice: '',
			sellPrice: '',
			innerBuyPrice: '',
			innerSellPrice: '',
			orderNumber: '',
			isVisible: 'N',
			isHead: 'N',
			otp: '',
		},

		selectedItem: null,

		confirm: {
			// to change percent 2 ^ 5 %
			percent: '',
		},
	},

	deleteItem: {
		_delete: 'init',

		selectedItem: null,
	},

	visibleItem: {
		_visible: 'init',

		selectedItem: null,
	},

	headItem: {
		_head: 'init',

		selectedItem: null,
	},

	fetchItemHistory: {
		_list: 'init',
		$list: [],

		selectedItem: null,

		from: 1,
		total: 0,
		size: 5,
	},
};

export default initState;
